<script>
import {
  useRoute,
  useFetch,
  useStore,
  computed,
} from "@nuxtjs/composition-api";

export default {
  setup() {
    const route = useRoute();
    const store = useStore();
    const questions = computed(() => {
      const helpList = store.state.helpCenter?.helpList
      const id = route.value.query.id
      if(!helpList) return []
      if (!id) {
        return helpList[0]?.helpCenter;
      } else {
        return helpList.find( (item) => item.id == id )?.helpCenter;
      }
    });
    useFetch(async () => {
      await store.dispatch("helpCenter/getHelpCenter");
    });
    return { questions };
  },
};
</script>

<template>
  <div class="wrap">
    <div
      v-for="item in questions"
      :key="item.question_id"
      class="wrap_question"
      @click="
        $router.push({
          path: '/helpcenter/question-answer',
          query: { id: $route.query.id, questionId: item.id },
        })
      "
    >
      <div class="wrap_question_circle"></div>
      <div class="wrap_question_text">{{ item.title }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrap {
  margin-left: 25px;
  margin-right: 25px;
  width: 100%;
}
.wrap_question {
  border-bottom-width: 1px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  height: 70px;
  width: 100%;
}
.wrap_question_circle {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  border-radius: 9999px;
  height: 7px;
  margin-right: 10px;
  width: 7px;
}
.wrap_question_text {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
}
</style>
